var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Explore"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.04114 28.2928C0.608385 32.2492 3.63765 35.9012 7.87863 36.4337C12.1196 36.9663 15.9278 34.2273 16.3606 30.3471C16.7933 26.4668 13.7641 22.7387 9.52309 22.2061C5.28211 21.6736 1.47389 24.3365 1.04114 28.2928V28.2928Z",
    stroke: "white",
    strokeWidth: 1.43806,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.47461 26.4668L10.8221 3.18532C12.1203 1.35932 17.7461 -0.0862652 19.304 5.01132L16.3613 30.1189",
    stroke: "white",
    strokeWidth: 1.43806,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.6809 28.2928C41.1136 32.2492 38.0844 35.9012 33.8434 36.4337C29.6024 36.9663 25.7942 34.2273 25.3614 30.3471C24.9287 26.4668 27.958 22.7387 32.1989 22.2061C36.4399 21.6736 40.2481 24.3365 40.6809 28.2928V28.2928Z",
    stroke: "white",
    strokeWidth: 1.43806,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.2493 26.4668L30.9019 3.18532C29.6036 1.35932 23.9778 -0.0862652 22.4199 5.01132L25.3626 30.1189",
    stroke: "white",
    strokeWidth: 1.43806,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.957 8.13074H22.7653",
    stroke: "white",
    strokeWidth: 1.43806,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.0527 21.0649H24.6692",
    stroke: "white",
    strokeWidth: 1.43806,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.5782999d4d86f252cd9af7607903280a.svg";
export { ForwardRef as ReactComponent };